import { render, staticRenderFns } from "./AddClientPopup.vue?vue&type=template&id=f83d64ea&scoped=true"
import script from "./AddClientPopup.vue?vue&type=script&lang=js"
export * from "./AddClientPopup.vue?vue&type=script&lang=js"
import style0 from "./AddClientPopup.vue?vue&type=style&index=0&id=f83d64ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83d64ea",
  null
  
)

export default component.exports